<template>
    <!-- Section: top slider -->
    <!-- <section id="intro" class="intro">
      <div class="intro-content">
        <div class="container">
          <vue-flux
        :options="fluxOptions"
        :images="fluxImages"
        :transitions="fluxTransitions"
        :captions="fluxCaptions"
        ref="slider">
            <FluxPagination slot="pagination"></FluxPagination>
            <CustomControls v-if="mounted" slot="controls" :slider="$refs.slider"></CustomControls>          
            <FluxCaption slot="caption"></FluxCaption>
        </vue-flux>
        </div>
      </div>
    </section>       -->    
      <div class="top-slider-container ">
        <div style="display:none;">
          <vue-flux
            :options="fluxOptions"
            :images="fluxImages"
            :transitions="fluxTransitions"
            :captions="fluxCaptions"
            ref="slider">
                <FluxPagination slot="pagination"></FluxPagination>
                <CustomControls v-if="mounted" slot="controls" :slider="$refs.slider"></CustomControls>          
                <FluxCaption slot="caption"></FluxCaption>
        </vue-flux>        
        </div>
        <div class="div-video-container">
            <video loop="true" autoplay="autoplay" controls muted>
              <source src="image/video/NataliKernChineseMedicine.mp4" type="video/mp4">
            </video>
        </div>   
      </div>
      
    <!-- /Section: top slider -->
</template>

<script>
  import { VueFlux, FluxPagination, Transitions, CustomControls, FluxCaption, } from 'vue-flux';
  import { getDataFromServer } from '../utils/DataProvider';
  export default {
     components: {
      VueFlux,
      FluxPagination,
      CustomControls,
      FluxCaption,      
   },
   data: () => ({
      fluxOptions: {
         autoplay: true,         
         height: "650px"
      },
      fluxImages:[], //[ '/image/topslider/_JP17069.jpg', '/image/topslider/_JP17201.jpg', '/image/topslider/_JP17243-2.jpg', "/image/topslider/_JP17277.jpg", "/image/topslider/_JP18034.jpg"],
      fluxCaptions:[], //['fluxCaptions 1', 'fluxCaptions 2', 'fluxCaptions 3', 'fluxCaptions 4','fluxCaptions 5'],
      fluxTransitions: {
         transitionBook: Transitions.transitionBook
      },
      mounted: false,

   }),
   methods:{
     getImagesFromServer(){
       getDataFromServer('list_gallery_byplace', {mediatype: 'image', place: 'home_image_slider'})
       .then(obj => {        
              if(obj.data.success === true){
                //console.log('list gallery slider: ', obj.data.data)
                for(let i = 0; i < obj.data.data.length; i++){                    
                    let element = obj.data.data[i];                    
                    this.fluxImages.push('/image/gallery/' + element.link);
                    this.fluxCaptions.push(element.title);
                }
                mounted = true;
                this.flash('add image success ' , 'success', {timeout: 4000})                
              }
              else{
                this.flash('add image error: ' + obj.data.text , 'error', {timeout: 4000})
              }            
       })
       .catch(err => {            
          this.flash('add image error: ' + err, 'error', {timeout: 4000})           
       });
     }
   },
   created(){
     this.getImagesFromServer();
   }
  }
</script>

<style scoped>
  .main-container{
     background: url('/image/gallery/_JP17215.jpg') no-repeat top center;
  }

  .top-slider-container{
    margin-top: 137px;
   
  }

  .intro-content{
    padding: 0;
    margin-top: 138px;
    background-size: cover; 
  }

  .flux-caption{
    bottom: 0 !important;
    top: unset !important;
    height: 180px;
  }

  .div-video-container{
    display: flex;
    justify-content: center;
  }

  @media(max-width:1200px){
    .top-slider-container{
      margin-top: 70px;
    }
  }

  @media screen and (max-width: 767px){
      .intro-content{
        padding: 0;
        margin-top: 90px;
        background-size: cover; 
      }

      .div-video-container video{
        width: 100%;
      }
  }
</style>